import * as classNames from 'classnames';
import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';

import { Link } from 'react-router-dom';
import { InjectedApiProps, withApi } from 'src/_context/Api';
import responsive from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import stylesheet, { directions } from 'src/constants/stylesheet';
import FadeInUp from 'src/utils/FadeInUp';
import { Language } from 'src/utils/Languages';
import ViewMonitor from 'src/utils/ViewMonitor';

export type SiteMapProps =
    React.HTMLAttributes<HTMLElement> &
    {
        articles: ArticleDto[];
    };

const styles = {
    container: {
        ...stylesheet.PaddingGutter(2, directions.bottom)
    },
    bottomLine: {
        display: 'block',
        height: 1,
        width: 0,
        margin: '0 auto',
        backgroundColor: 'black',
        transition: 'width .3s linear',
        backfaceVisibility: 'hidden',
        transform: 'translate3d(0,0,0)',
        ...stylesheet.MarginGutter(2, directions.bottom)
    },
    bottomLineShow: {
        [responsive.BeforeTablet]: {
            width: `calc(100% - ${spacing.Gutter.Desktop * 1}px)`
        },
        [responsive.AfterTablet]: {
            width: `calc(100% - ${spacing.Gutter.Desktop * 2}px)`
        }
    },
    title: {
        ...stylesheet.Subtitle_1,
        textAlign: 'center',
        ...stylesheet.PaddingGutter(1, directions.sides | directions.bottom)
    },
    menus: {
        position: 'relative',

        [responsive.Mobile]: {},
        [responsive.AfterMobile]: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            width: '100%',
            flex: '1 0 50%',
        },
    },
    menu: {
        height: '50%',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        boxSizing: 'border-box',
        justifyContent: 'center',
        ...stylesheet.PaddingGutter(.5, directions.top | directions.bottom),
        
        [responsive.AfterMobile]: {
            ...stylesheet.PaddingGutter(.25, directions.top | directions.bottom),
        }
    },
    menuLink: {
        ...stylesheet.Link(false, 'center')
    },
    submenuLink: {
        ...stylesheet.Link(false, 'center', 5)
    },
    menuTitle: {
        ...stylesheet.Subtitle_2,
        marginBottom: 6,
        [responsive.Mobile]: {
            paddingTop: 10,
            paddingBottom: 4,
            paddingLeft: 20,
            paddingRight: 20
        }
    },
    menuItem: {
        ...stylesheet.Subtitle_1,
        marginBottom: 4,
    },
    Subtitle_2: {
        ...stylesheet.Subtitle_2,
    },
    remaningMenus: {
        textAlign: 'center',
        boxSizing: 'border-box',
        ...stylesheet.PaddingGutter(.5, directions.top | directions.bottom),
        
        [responsive.AfterMobile]: {
            ...stylesheet.PaddingGutter(.25, directions.top | directions.bottom),
        }
    },
    remaningMenu: {
        ...stylesheet.Link(false, 'center', 5),
    }
};

type Props = SiteMapProps &
    StyledComponentProps<keyof typeof styles> &
    InjectedApiProps;

type State = {
    // menus: MenuItemDto[];
};
class SiteMap extends React.Component<Props, State> {
    public readonly state: State = {}
    private container: React.RefObject<HTMLElement> = React.createRef<HTMLElement>();
    render() {
        const {
            children,
            classes,
            articles,
            apiCtx: { app },
            ...rest
        } = this.props;

        const menus = app!.Menus;

        return (
            <section
                ref={this.container}
                {...rest}
                className={classes!.container}
            >
                <ViewMonitor>
                    {(isVisible) =>
                        <div className={classNames(classes!.bottomLine, isVisible && classes!.bottomLineShow)} />
                    }
                </ViewMonitor>
                <h3 className={classes!.title}>Site map</h3>
                <div className={classes!.menus}>
                    {articles.map((a) => {
                        const sections = a.Sections;
                        return (
                            <FadeInUp key={a.UID}>
                                <nav className={classes!.menu}>
                                    <ul>
                                        <li
                                            className={classNames(classes!.menuTitle, classes!.Subtitle_2)}
                                        >
                                            <Link
                                                className={classes!.menuLink}
                                                to={`/${Language}/home/${a.UID}`}
                                            >
                                                {a.Title}
                                            </Link>
                                        </li>
                                        {sections.map((s) => {
                                            return (
                                                <li
                                                    key={s.UID}
                                                    className={classes!.menuItem}
                                                >
                                                    <Link
                                                        className={classes!.submenuLink}
                                                        to={`/${Language}/home/${a.UID}/${s.UID}`}
                                                    >
                                                        {s.Title}
                                                    </Link>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </nav>
                            </FadeInUp>
                        );
                    })}

                    <div className={classes!.remaningMenus}>
                        {menus.map((m, i) => {
                            if (i <= 1) { return; }

                            return <div key={m.UID}>
                                <Link
                                    className={classNames(classes!.menuItem, classes!.remaningMenu)}
                                    to={`/${Language}/home/${m.UID}`}
                                >
                                    {m.Title}
                                </Link>
                            </div>
                        })}
                    </div>
                </div>
            </section>);
    }
}

export default withStyles(styles)(withApi(SiteMap));


// WEBPACK FOOTER //
// ./src/components/SiteMap.tsx